/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Split_PplInputs */

const en_us2_plan_split_ppl = /** @type {(inputs: Plan_Split_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push · pull · legs`)
};

const pt_br2_plan_split_ppl = /** @type {(inputs: Plan_Split_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar · puxar · pernas`)
};

const es_419_plan_split_ppl = /** @type {(inputs: Plan_Split_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empuje · tirón · piernas`)
};

const pt_pt2_plan_split_ppl = /** @type {(inputs: Plan_Split_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar · puxar · pernas`)
};

const fr_fr2_plan_split_ppl = /** @type {(inputs: Plan_Split_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poussée · tirage · jambes`)
};

const de_de2_plan_split_ppl = /** @type {(inputs: Plan_Split_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drücken · Ziehen · Beine`)
};

const it_it2_plan_split_ppl = /** @type {(inputs: Plan_Split_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spinta · tirata · gambe`)
};

/**
* | output |
* | --- |
* | "Push · pull · legs" |
*
* @param {Plan_Split_PplInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_split_ppl = /** @type {((inputs?: Plan_Split_PplInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Split_PplInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_split_ppl(inputs)
	if (locale === "es-419") return es_419_plan_split_ppl(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_split_ppl(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_split_ppl(inputs)
	if (locale === "de-DE") return de_de2_plan_split_ppl(inputs)
	if (locale === "it-IT") return it_it2_plan_split_ppl(inputs)
	return en_us2_plan_split_ppl(inputs)
});
export { plan_split_ppl as "plan.split.ppl" }